import { useState, useEffect, useRef } from "react"

function BuscadorMedico({ doctores, value, onChange }) {
  const medico = doctores.find(d => String(d.id) === String(value)) || null
  const [query, setQuery]       = useState("")
  const [abierto, setAbierto]   = useState(false)
  const ref                     = useRef(null)

  const filtrados = query.trim()
    ? doctores.filter(d =>
        d.pdNombre.toLowerCase().includes(query.toLowerCase()) ||
        (d.pdEspecialidad || "").toLowerCase().includes(query.toLowerCase())
      )
    : doctores

  useEffect(() => {
    const cerrar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false) }
    document.addEventListener("mousedown", cerrar)
    return () => document.removeEventListener("mousedown", cerrar)
  }, [])

  const handleSelect = (d) => {
    onChange(d ? String(d.id) : "")
    setQuery("")
    setAbierto(false)
  }

  const handleInputChange = (e) => {
    setQuery(e.target.value)
    setAbierto(true)
    if (!e.target.value) onChange("")
  }

  const displayValue = abierto ? query : (medico ? medico.pdNombre : "")

  return (
    <div className="buscadorMedico" ref={ref}>
      <input
        type="text"
        placeholder="buscar médico..."
        value={displayValue}
        onChange={handleInputChange}
        onFocus={() => setAbierto(true)}
        style={{ width: 250 }}
      />
      {abierto && (
        <div className="buscadorMedicoDropdown">
          <div
            className="buscadorMedicoItem buscadorMedicoItem--vacio"
            onMouseDown={() => handleSelect(null)}
          >
            sin asignar
          </div>
          {filtrados.length === 0 ? (
            <div className="buscadorMedicoItem buscadorMedicoItem--vacio">sin resultados</div>
          ) : (
            filtrados.map(d => (
              <div
                key={d.id}
                className={`buscadorMedicoItem${String(d.id) === String(value) ? " buscadorMedicoItem--activo" : ""}`}
                onMouseDown={() => handleSelect(d)}
              >
                <span className="buscadorMedicoNombre">{d.pdNombre}</span>
                {d.pdEspecialidad && <span className="buscadorMedicoEsp">{d.pdEspecialidad}</span>}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default BuscadorMedico